// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"465":"a25beec6","862":"a62db295"}[chunkId] + ".chunk.js";
};